// extracted by mini-css-extract-plugin
module.exports = {"menu":"navbar-module--menu--3ILRJ","menuOpen":"navbar-module--menu-open--3wbyg","navbarLink":"navbar-module--navbar-link--1dF6B"};